import { Injectable, inject } from '@angular/core';
import { Actions, Store } from '@ngxs/store';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { BreadcrumbsService } from '../services/breadcrumbs/breadcrumbs.service';
import { NotificationsService } from '../services/notifications-service/notifications.service';
import { PushNotificationsService } from '../services/push-notifications.service';
import { ShortcutKeysService } from '../services/shortcutKeys/shortcutKeys.service';
import { TranslationService } from '../transloco/services/translation.service';
import { ConfirmationModalService } from './confirmation-modal/confirmation-modal.service';

@Injectable({ providedIn: 'root' })
export class ComponentBaseService {
    public store = inject(Store);
    public loaderService = inject(NgxUiLoaderService);
    public actions$ = inject(Actions);
    public breadcrumbs = inject(BreadcrumbsService);
    public shortcutKeysService = inject(ShortcutKeysService);
    public pushNotificationsService = inject(PushNotificationsService);
    public notificationsService = inject(NotificationsService);
    public confirmationModalService = inject(ConfirmationModalService);
    public translationService = inject(TranslationService);
}
